import { fragments as embroideryOrderStatusFragments } from "../../application/apps/EmbroideryApp/components/EmbroideryOrderStatus/graph";
import { gql } from "@apollo/client";

const markOrderAsEmbroideryStartedMutation = gql`
  mutation($orderId: ID!) {
    markOrderAsEmbroideryStarted(orderId: $orderId) {
      errors {
        orderId
      }
      order {
        ...EmbroideryOrderStatus_order
      }
      succeeded
    }
  }
  ${embroideryOrderStatusFragments.order}
`;

export default markOrderAsEmbroideryStartedMutation;
